import { createContext } from 'react';

export interface PrepaidContextType {
    amount: number;
    setAmount: (amount: number) => void;
}

const PrepaidContext = createContext<PrepaidContextType>({
  amount: 0,
  setAmount: () => {},
});

export default PrepaidContext;
